import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Label, Col, Row, FormGroup} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import {Utils} from "../../../utils/utils";
import {ASSISTANT_TYPES} from "../../../constants/constants";

class EditAssistantModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            roles: []
        };
    }

    componentWillUpdate(nextProps) {
        if (!_.isEqual(this.props.data, nextProps.data) && !_.isNil(nextProps.data)) {
            this.setState({
                roles: nextProps.data.roles
            })
        }
    }

    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal className="assistant-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <div>
                <h6>
                    {_.get(this.props.translation, 'assistants.edit_assistant_alert')}
                </h6>
                {this.getRolesSelectFormGroup()}
                {this.renderData()}
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn"
                            onClick={this.handleRemove}>{_.get(this.props.translation, sharedLabelsPath.save_changes_button)}</Button>
                </div>
            </div>
        );
    }

    getRolesSelectFormGroup = (params) => {
        params = {
            value: 'roles',
            title: _.get(this.props.translation, 'assistants.roles_label'),
            type: 'select',
            isRequired: true,
            isMulti: true,
            content: Utils.getOptions(
                _.map(ASSISTANT_TYPES, value => ({
                    code: value,
                    name: _.get(this.props.translation, 'assistants.' + value + '_label')
                }))
            ),
            placeholder: _.get(this.props.translation, 'assistants.roles_select_placeholder'),
            onChange: this.handleChangeRoleSelect
        };


        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            isMulti={params.isMulti}
                            selectedOption={_.filter(params.content, option => this.state[params.value].includes(option.value))}
                            options={params.content}
                            onSelect={params.onChange || this.handleChangeSelect(params.value)}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    handleChangeRoleSelect = (selectedOptions) => {
        this.setState({roles: selectedOptions.map(option => option.value)});
    };

    renderData = () => {
        let paramsList = [
            {
                key: "firstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                value: this.props.data.firstName
            },
            {
                key: "lastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                value: this.props.data.lastName
            },
            {
                key: "email",
                title: _.get(this.props.translation, sharedLabelsPath.email_label),
                value: this.props.data.email
            },
            {
                key: "country",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                value: _.get(this.props.translation, 'countries.' + this.props.data.countryCode)
            }
        ];

        return [..._.map(paramsList, this.getDataRow)]
    };

    getDataRow = (params) => {
        if (_.isNil(params.value)) {
            return null;
        }

        return (
            <Row className="modal-form-field-container" key={params.key}>
                <Col sm={4}>
                    {params.title}
                </Col>
                <Col>
                    {params.value}
                </Col>
            </Row>
        );
    };

    handleRemove = (e) => {
        e.preventDefault();

        let data = {
            hasRootPermission: false,
            hasFinancialManagerPermission: this.state.roles.includes(ASSISTANT_TYPES.FINANCIAL_ASSISTANT),
            hasProcessingManagerPermission: this.state.roles.includes(ASSISTANT_TYPES.PROCESS_ASSISTANT)
        };
        this.props.onAssistantEdit(this.props.data.id, data);
        this.props.onClose();
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.onCancelEditing();
    };
}

EditAssistantModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onAssistantEdit: PropTypes.func,
    onClose: PropTypes.func,
    onCancelEditing: PropTypes.func
};

export default EditAssistantModal;



// WEBPACK FOOTER //
// ./src/components/assistantsManagement/editAssistantModal/EditAssistantModal.js